export default __webpack_public_path__ + "media/images/dashboard_icons/invites-cc36d9998ba9a6c38ed5d091d21bb57d.svg";